export const languages = ["en", "fr", "de", "pt", "es"];
